import React from 'react';
import './Home.css'
import VideoSection from './VideoSection'
import Ser from './Ser'
import Fire from './Fire'
import Shr  from './Shr';
const Home = () => {
  return (
    <>
    <VideoSection />
    <Ser />
    <div className='n'>
    <img src='https://assets.oyoroomscdn.com/cmsMedia/f0be8dc3-e384-40b3-89f9-a0a0109159ce.jpg' alt='op' className='uio'></img>
    </div>
    <div>
      <img src='https://assets.oyoroomscdn.com/cmsMedia/ac15627f-c423-4383-a43b-1402ef8c3a73.png' alt='po' className='uiio'></img>
    </div>
    <Fire />
 <Shr />

    </>
  );
};

export default Home;
